import { Container } from "react-bootstrap";
import CandidatesList from "./CandidatesList";

export default function CandidatesIndex() {
    return (
        <Container>
            <CandidatesList />
        </Container>
    )
}
